var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03019 0.376718C5.95942 0.444208 5.89958 0.518253 5.84759 0.595345L0.397242 5.79282C0.132349 6.04524 -1.36294e-08 6.37613 0 6.70703C1.36294e-08 7.03792 0.132349 7.36863 0.397242 7.62123C0.926835 8.12626 1.78561 8.12626 2.31501 7.62123L7.01221 3.14261L11.6851 7.59871C12.215 8.10373 13.0735 8.10373 13.6029 7.59871C14.1325 7.09368 14.1322 6.27494 13.6032 5.76992L8.17722 0.595436C8.12523 0.518344 8.06549 0.444299 7.99462 0.377086C7.72392 0.118944 7.36734 -0.00560284 7.01231 0.000213146C6.65747 -0.00588036 6.30109 0.118391 6.03019 0.376718Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron.3a3174d4d5940ba1e9bc6e69b613c861.svg";